export const LOADER_MOTIVOS         =       'LOADER_MOTIVOS';
export const GET_MOTIVOS            =       'GET_MOTIVOS';
export const MOTIVOS_FALLA          =       'MOTIVOS_FALLA';
export const SAVE_LOADER_MOTIVOS    =       'SAVE_LOADER_MOTIVOS';
export const FORM_MOTIVOS_FAIL      =       'FORM_MOTIVOS_FAIL';

